import React from "react";

function Download2Icon (props) {
    const { fill, classname, onclick } = props;

    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={ fill } className={ (classname !== undefined ? classname : "") } onClick={ (onclick !== undefined ? onclick : () => {}) }><g id="Icon"><path d="m22.736 3.297c.072-.474-.13-.949-.521-1.228-.391-.278-.906-.313-1.331-.09-3.401 1.786-15.298 8.032-18.952 9.95-.451.236-.717.718-.678 1.225s.375.943.857 1.108c1.423.487 3.162 1.084 5.889 2.019l11-10.281-8.902 11c2.908.997 7.455 2.556 8.596 2.947.357.123.751.08 1.074-.115.323-.196.542-.525.599-.899z"></path><path d="m8.832 17.623v3.27c0 .502.295.957.752 1.162.458.206.993.124 1.368-.21l2.838-2.522z"></path></g></svg>
    );
}

export default Download2Icon;
